// src/services/focalApiService.ts
export interface AgentTaskStats {
  email: string;
  total_draw_tasks: number;
  total_match_draw_edit_tasks: number;
  total_pair_tasks: number;
  total_review_tasks: number;
}

export interface ProcessedAgentTaskStats extends AgentTaskStats {
  pair_only_tasks: number;
  total_all_tasks: number;
}

export interface AgentPerformanceStats {
  email: string;
  total_gs_tasks: number;
  average_draw_score: number;
  average_pair_score: number;
  average_label_score: number;
  average_area_score: number;
  total_average_f1: number;
}

export interface TotalTasksParams {
  dateFrom: string;
  dateTo: string;
  selectedAgents?: string[];
}

export interface CombinedTasksAndPerformanceResult {
  taskStats: ProcessedAgentTaskStats[];
  performanceStats: AgentPerformanceStats[];
}

// Types TypeScript mis à jour
interface Agent {
  email: string;
  displayName: string;
  userId: string;
}

interface AuditDataParams {
  dateFrom?: string;
  dateTo?: string;
  userEmail?: string;
  userId?: string;
}

interface ParsedTask {
  match_task_id: number;
  date: string;
  state: string;
  email: string;
  priority_names?: string;
  issue_names?: string;
  processing_time_seconds: number;
  template_unpaired: number;
  template_total: number;
  plano_unpaired: number;
  plano_total: number;
  template_image?: string;
  plano_image?: string;
  model_drawn_template?: string;
  template_image_urls: string[];
  plano_image_urls: string[];
  model_drawn_template_urls: string[];
  agent_submitted_urls: string[];
  model_template_used: number;
  unlock_draw_mode_used: number;
  task_type: 'pair_only' | 'complete_match';
}

interface TaskStats {
  totalTasks: number;
  completedTasks: number;
  rejectedTasks: number;
  avgProcessingTime: number;
  tasksByAgent: { [email: string]: AgentStats };
  tasksByDay: { [date: string]: DayStats };
}

interface AgentStats {
  total: number;
  completed: number;
  rejected: number;
}

interface DayStats {
  total: number;
  completed: number;
  rejected: number;
}

// Fonction utilitaire pour attendre
const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// Configuration API - SERVEUR PROXY EXTERNE SEULEMENT
const USE_EXTERNAL_PROXY = true;
// 🔧 FIX: Forcer l'URL du proxy
const PROXY_SERVER_URL = process.env.REACT_APP_PROXY_URL || 'http://localhost:3001';
const FOCAL_API_BASE_URL = PROXY_SERVER_URL;

console.log('🔧 Configuration API:', {
  USE_EXTERNAL_PROXY,
  PROXY_SERVER_URL,
  FOCAL_API_BASE_URL,
  env_proxy_url: process.env.REACT_APP_PROXY_URL,
  env_focal_url: process.env.REACT_APP_FOCAL_API_URL
});

// IDs des requêtes Redash
const QUERY_IDS = {
  PAIR_ONLY_TASKS: '5374',
  COMPLETE_MATCH_TASKS: '5375'
};

// 🆕 MAPPING COMPLET des emails vers userIDs
const EMAIL_TO_USER_ID: { [key: string]: string } = {
  'agent-251@oworkers.com': '49456', 
  'agent-250@oworkers.com': '49455', 
  'agent-249@oworkers.com': '49454',
  'agent-248@oworkers.com': '49453', 
  'agent-247@oworkers.com': '49452', 
  'agent-246@oworkers.com': '49451', 
  'agent-245@oworkers.com': '49450', 
  'agent-244@oworkers.com': '49449', 
  'agent-243@oworkers.com': '49448', 
  'agent-242@oworkers.com': '49447', 
  'agent-241@oworkers.com': '49446', 
  'agent-240@oworkers.com': '49445', 
  'agent-239@oworkers.com': '49444', 
  'agent-238@oworkers.com': '49443', 
  'agent-237@oworkers.com': '49442', 
  'agent-236@oworkers.com': '49441', 
  'agent-235@oworkers.com': '49440', 
  'agent-234@oworkers.com': '49439', 
  'agent-233@oworkers.com': '49438', 
  'agent-232@oworkers.com': '49437', 
  'agent-231@oworkers.com': '49436', 
  
  'agent-230@oworkers.com': '15390',
  'agent-229@oworkers.com': '15389',
  'agent-228@oworkers.com': '15388',
  'agent-227@oworkers.com': '15387',
  'agent-226@oworkers.com': '15386',
  'agent-225@oworkers.com': '15385',
  'agent-224@oworkers.com': '15384',
  'agent-223@oworkers.com': '15383',
  'agent-222@oworkers.com': '15382',
  'agent-221@oworkers.com': '15381',
  'agent-220@oworkers.com': '15380',
  'agent-219@oworkers.com': '15379',
  'agent-218@oworkers.com': '15378',
  'agent-217@oworkers.com': '15377',
  'agent-216@oworkers.com': '15376',
  'agent-215@oworkers.com': '15375',
  'agent-214@oworkers.com': '15374',
  'agent-213@oworkers.com': '15373',
  'agent-212@oworkers.com': '15372',
  'agent-211@oworkers.com': '15371',
  'agent-210@oworkers.com': '15370',
  'agent-209@oworkers.com': '15369',
  'agent-208@oworkers.com': '15368',
  'agent-207@oworkers.com': '15366',
  'agent-206@oworkers.com': '15365',
  'agent-205@oworkers.com': '15364',
  'agent-204@oworkers.com': '15363',
  'agent-203@oworkers.com': '15362',
  'agent-202@oworkers.com': '15361',
  'agent-201@oworkers.com': '15360',

  // Agents 181-200
  'agent-200@oworkers.com': '9944',
  'agent-199@oworkers.com': '9943',
  'agent-198@oworkers.com': '9942',
  'agent-197@oworkers.com': '9941',
  'agent-196@oworkers.com': '9940',
  'agent-195@oworkers.com': '9939',
  'agent-194@oworkers.com': '9938',
  'agent-193@oworkers.com': '9937',
  'agent-192@oworkers.com': '9936',
  'agent-191@oworkers.com': '9935',
  'agent-190@oworkers.com': '9934',
  'agent-189@oworkers.com': '9933',
  'agent-188@oworkers.com': '9932',
  'agent-187@oworkers.com': '9931',
  'agent-186@oworkers.com': '9930',
  'agent-185@oworkers.com': '9929',
  'agent-184@oworkers.com': '9928',
  'agent-183@oworkers.com': '9927',
  'agent-182@oworkers.com': '9926',
  'agent-181@oworkers.com': '9925',

  // Agents 161-180
  'agent-180@oworkers.com': '7930',
  'agent-179@oworkers.com': '7929',
  'agent-178@oworkers.com': '7928',
  'agent-177@oworkers.com': '7927',
  'agent-176@oworkers.com': '7926',
  'agent-175@oworkers.com': '7925',
  'agent-174@oworkers.com': '7924',
  'agent-173@oworkers.com': '7923',
  'agent-172@oworkers.com': '7922',
  'agent-171@oworkers.com': '7921',
  'agent-170@oworkers.com': '7920',
  'agent-169@oworkers.com': '7919',
  'agent-168@oworkers.com': '7918',
  'agent-167@oworkers.com': '7916',
  'agent-166@oworkers.com': '7915',
  'agent-165@oworkers.com': '7914',
  'agent-164@oworkers.com': '7913',
  'agent-163@oworkers.com': '7912',
  'agent-162@oworkers.com': '7911',
  'agent-161@oworkers.com': '7910',
  'agent-160@oworkers.com': '7268',
  'agent-159@oworkers.com': '7267',
  'agent-158@oworkers.com': '7266',
  'agent-157@oworkers.com': '7265',
  'agent-156@oworkers.com': '7264',
  'agent-155@oworkers.com': '7263',
  'agent-154@oworkers.com': '7262',
  'agent-153@oworkers.com': '7260',
  'agent-152@oworkers.com': '7259',
  'agent-151@oworkers.com': '7258',
  'agent-150@oworkers.com': '7257',
  'agent-149@oworkers.com': '7256',
  'agent-148@oworkers.com': '7255',
  'agent-147@oworkers.com': '7254',
  'agent-146@oworkers.com': '7253',
  'agent-145@oworkers.com': '7252',
  'agent-144@oworkers.com': '7251',
  'agent-143@oworkers.com': '7250',
  'agent-142@oworkers.com': '7249',
  'agent-141@oworkers.com': '7248',
  'agent-140@oworkers.com': '7247',
  'agent-139@oworkers.com': '7246',
  'agent-138@oworkers.com': '7131',
  'agent-137@oworkers.com': '7130',
  'agent-136@oworkers.com': '7129',
  'agent-135@oworkers.com': '7128',
  'agent-134@oworkers.com': '7127',
  'agent-133@oworkers.com': '7126',
  'agent-132@oworkers.com': '7125',
  'agent-131@oworkers.com': '7124',
  'agent-130@oworkers.com': '7123',
  'agent-129@oworkers.com': '7122',
  'agent-128@oworkers.com': '7121',
  'agent-127@oworkers.com': '7120',
  'agent-126@oworkers.com': '7119',
  'agent-125@oworkers.com': '7118',
  'agent-124@oworkers.com': '7117',
  'agent-123@oworkers.com': '7116',
  'agent-122@oworkers.com': '7115',
  'agent-121@oworkers.com': '7114',
  'agent-120@oworkers.com': '7113',
  'agent-119@oworkers.com': '7112',
  'agent-118@oworkers.com': '7111',
  'agent-117@oworkers.com': '7109',
  'agent-116@oworkers.com': '7108',

  // Agents 101-116
  'agent-115@oworkers.com': '6712',
  'agent-114@oworkers.com': '6711',
  'agent-113@oworkers.com': '6710',
  'agent-112@oworkers.com': '6709',
  'agent-111@oworkers.com': '6708',
  'agent-110@oworkers.com': '6707',
  'agent-109@oworkers.com': '6706',
  'agent-108@oworkers.com': '6719',
  'agent-107@oworkers.com': '6705',
  'agent-106@oworkers.com': '6704',
  'agent-105@oworkers.com': '6703',
  'agent-104@oworkers.com': '6702',
  'agent-103@oworkers.com': '6701',
  'agent-102@oworkers.com': '6700',
  'agent-101@oworkers.com': '6699',

  // Agents 81-100
  'agent-100@oworkers.com': '6502',
  'agent-99@oworkers.com': '6501',
  'agent-98@oworkers.com': '6500',
  'agent-97@oworkers.com': '6499',
  'agent-96@oworkers.com': '6498',
  'agent-95@oworkers.com': '6497',
  'agent-94@oworkers.com': '6496',
  'agent-93@oworkers.com': '6495',
  'agent-92@oworkers.com': '6494',
  'agent-91@oworkers.com': '6493',
  'agent-90@oworkers.com': '6492',
  'agent-89@oworkers.com': '6491',
  'agent-88@oworkers.com': '6490',
  'agent-87@oworkers.com': '6489',
  'agent-86@oworkers.com': '6488',
  'agent-85@oworkers.com': '6487',
  'agent-84@oworkers.com': '6486',
  'agent-83@oworkers.com': '6485',
  'agent-82@oworkers.com': '6484',
  'agent-81@oworkers.com': '6483',

  // Agents 61-80
  'agent-80@oworkers.com': '6482',
  'agent-79@oworkers.com': '6481',
  'agent-78@oworkers.com': '6480',
  'agent-77@oworkers.com': '6479',
  'agent-76@oworkers.com': '6478',
  'agent-75@oworkers.com': '6387',
  'agent-74@oworkers.com': '6386',
  'agent-73@oworkers.com': '6385',
  'agent-72@oworkers.com': '6384',
  'agent-71@oworkers.com': '6383',
  'agent-70@oworkers.com': '6382',
  'agent-69@oworkers.com': '6381',
  'agent-68@oworkers.com': '6380',
  'agent-67@oworkers.com': '6379',
  'agent-66@oworkers.com': '6378',
  'agent-65@oworkers.com': '6377',
  'agent-64@oworkers.com': '6376',
  'agent-63@oworkers.com': '6375',
  'agent-62@oworkers.com': '6374',
  'agent-61@oworkers.com': '6373',

  // Agents 41-60
  'agent-60@oworkers.com': '6372',
  'agent-59@oworkers.com': '6371',
  'agent-58@oworkers.com': '6370',
  'agent-57@oworkers.com': '6369',
  'agent-56@oworkers.com': '6368',
  'agent-55@oworkers.com': '6363',
  'agent-54@oworkers.com': '6362',
  'agent-53@oworkers.com': '6361',
  'agent-52@oworkers.com': '6360',
  'agent-51@oworkers.com': '6359',
  'agent-50@oworkers.com': '6358',
  'agent-49@oworkers.com': '6357',
  'agent-48@oworkers.com': '6356',
  'agent-47@oworkers.com': '6355',
  'agent-46@oworkers.com': '6354',
  'agent-45@oworkers.com': '6353',
  'agent-44@oworkers.com': '6352',
  'agent-43@oworkers.com': '6351',
  'agent-42@oworkers.com': '6350',
  'agent-41@oworkers.com': '6349',

  // Agents 21-40
  'agent-40@oworkers.com': '6336',
  'agent-39@oworkers.com': '6335',
  'agent-38@oworkers.com': '6334',
  'agent-37@oworkers.com': '6333',
  'agent-36@oworkers.com': '6332',
  'agent-35@oworkers.com': '6331',
  'agent-34@oworkers.com': '6330',
  'agent-33@oworkers.com': '6329',
  'agent-32@oworkers.com': '6328',
  'agent-31@oworkers.com': '6327',
  'agent-30@oworkers.com': '6326',
  'agent-29@oworkers.com': '6325',
  'agent-28@oworkers.com': '6324',
  'agent-27@oworkers.com': '4386',
  'agent-26@oworkers.com': '4385',
  'agent-25@oworkers.com': '4384',
  'agent-24@oworkers.com': '4383',
  'agent-23@oworkers.com': '4269',
  'agent-22@oworkers.com': '4268',
  'agent-21@oworkers.com': '4267',

  // Agents 0-20
  'agent-20@oworkers.com': '4266',
  'agent-19@oworkers.com': '4265',
  'agent-18@oworkers.com': '4264',
  'agent-17@oworkers.com': '4263',
  'agent-16@oworkers.com': '4262',
  'agent-15@oworkers.com': '4261',
  'agent-14@oworkers.com': '4260',
  'agent-13@oworkers.com': '4259',
  'agent-12@oworkers.com': '4258',
  'agent-11@oworkers.com': '4257',
  'agent-10@oworkers.com': '4256',
  'agent-9@oworkers.com': '4255',
  'agent-8@oworkers.com': '4254',
  'agent-7@oworkers.com': '4253',
  'agent-6@oworkers.com': '4252',
  'agent-5@oworkers.com': '4251',
  'agent-4@oworkers.com': '4250',
  'agent-3@oworkers.com': '4249',
  'agent-2@oworkers.com': '4248',
  'agent-1@oworkers.com': '4247',
  'agent-0@oworkers.com': '4246',

  // Comptes spéciaux
  'test@oworkers.com': '4284',
  'oworkers-test@focal.systems': '4689',

  // Comptes de formation (training_account)
  'training_account_50@oworkers.com': '13938',
  'training_account_49@oworkers.com': '13937',
  'training_account_48@oworkers.com': '13936',
  'training_account_47@oworkers.com': '13935',
  'training_account_46@oworkers.com': '13934',
  'training_account_45@oworkers.com': '13933',
  'training_account_44@oworkers.com': '13932',
  'training_account_43@oworkers.com': '13931',
  'training_account_42@oworkers.com': '13930',
  'training_account_41@oworkers.com': '13929',
  'training_account_40@oworkers.com': '13928',
  'training_account_39@oworkers.com': '13927',
  'training_account_38@oworkers.com': '13926',
  'training_account_37@oworkers.com': '13925',
  'training_account_36@oworkers.com': '13924',
  'training_account_35@oworkers.com': '13923',
  'training_account_34@oworkers.com': '13922',
  'training_account_33@oworkers.com': '9923',
  'training_account_32@oworkers.com': '9922',
  'training_account_31@oworkers.com': '9921',
  'training_account_30@oworkers.com': '9920',
  'training_account_29@oworkers.com': '9919',
  'training_account_28@oworkers.com': '9918',
  'training_account_27@oworkers.com': '9917',
  'training_account_26@oworkers.com': '9916',
  'training_account_25@oworkers.com': '9915',
  'training_account_24@oworkers.com': '9914',
  'training_account_23@oworkers.com': '9913',
  'training_account_22@oworkers.com': '9912',
  'training_account_21@oworkers.com': '9911',
  'training_account_20@oworkers.com': '9910',
  'training_account_19@oworkers.com': '9909',
  'training_account_18@oworkers.com': '9908',
  'training_account_17@oworkers.com': '9907',
  'training_account_16@oworkers.com': '9906',
  'training_account_15@oworkers.com': '9905',
  'training_account_14@oworkers.com': '9904',
  'training_account_13@oworkers.com': '9903',
  'training_account_12@oworkers.com': '9902',
  'training_account_11@oworkers.com': '9901',
  'training_account_10@oworkers.com': '9900',
  'training_account_9@oworkers.com': '9899',
  'training_account_8@oworkers.com': '7275',
  'training_account_7@oworkers.com': '7274',
  'training_account_6@oworkers.com': '7273',
  'training_account_5@oworkers.com': '7272',
  'training_account_4@oworkers.com': '7271',
  'training_account_3@oworkers.com': '7144',
  'training_account_2@oworkers.com': '7143',
  'training_account_1@oworkers.com': '7142'
};

const withApiBase = (base: string) => {
  const norm = (base || '').replace(/\/+$/,'');     // remove trailing slash
  return /\/api$/i.test(norm) ? norm : `${norm}/api`;
};

export class FocalApiService {
  private baseUrl: string;
  private useExternalProxy: boolean;

  constructor() {
    this.baseUrl = FOCAL_API_BASE_URL;
    this.useExternalProxy = USE_EXTERNAL_PROXY;
    
    console.log('🔧 FocalApiService configuré (PROXY SEULEMENT):', {
      baseUrl: this.baseUrl,
      useExternalProxy: this.useExternalProxy,
      proxyUrl: PROXY_SERVER_URL,
      totalAgents: Object.keys(EMAIL_TO_USER_ID).length
    });
  }

  /**
   * 🔧 Méthode pour construire les paramètres des TÂCHES (format simple)
   * Utilisée pour les requêtes 5374 et 5375 (getPairOnlyTasks, getCompleteMatchTasks)
   */
  private buildTaskParameters(params: AuditDataParams): any {
    const { dateFrom, dateTo, userEmail, userId } = params;
    
    const parameters: any = {};
    
    // FORMAT SIMPLE pour les tâches : date: "YYYY-MM-DD"
    if (dateFrom && dateTo) {
      if (dateFrom === dateTo) {
        parameters.date = dateFrom;
      } else {
        // Pour une plage, utiliser la date de début
        parameters.date = dateFrom;
      }
    } else if (dateFrom) {
      parameters.date = dateFrom;
    }
    
    // User ID
    if (userId) {
      parameters.user = userId;
    } else if (userEmail && EMAIL_TO_USER_ID[userEmail]) {
      parameters.user = EMAIL_TO_USER_ID[userEmail];
    }

    console.log('🔧 Paramètres TÂCHES construits (format simple):', parameters);
    return parameters;
  }

  /**
   * 🔧 Méthode pour construire les paramètres des STATISTIQUES (format objet)
   * Utilisée pour les requêtes 5372 et 5373 (statistiques)
   */
  private buildStatsParameters(params: AuditDataParams): any {
    const { dateFrom, dateTo, userEmail, userId } = params;
    
    const parameters: any = {};
    
    // FORMAT OBJET pour les statistiques : date: {start: "YYYY-MM-DD", end: "YYYY-MM-DD"}
    if (dateFrom && dateTo) {
      parameters.date = {
        start: dateFrom,
        end: dateTo
      };
    } else if (dateFrom) {
      parameters.date = {
        start: dateFrom,
        end: dateFrom
      };
    }
    
    // User ID
    if (userId) {
      parameters.user = userId;
    } else if (userEmail && EMAIL_TO_USER_ID[userEmail]) {
      parameters.user = EMAIL_TO_USER_ID[userEmail];
    }

    console.log('🔧 Paramètres STATS construits (format objet):', parameters);
    return parameters;
  }

  /**
   * 🔧 Méthode générique (garde l'ancienne pour compatibilité)
   * Par défaut, utilise le format simple des tâches
   */
  private buildParameters(params: AuditDataParams): any {
    return this.buildTaskParameters(params);
  }

  /**
   * 🆕 Méthode pour obtenir la liste complète des agents
   */
  getAllAvailableAgents(): Agent[] {
    const agents: Agent[] = [];
    
    for (const [email, userId] of Object.entries(EMAIL_TO_USER_ID)) {
      agents.push({
        email,
        displayName: this.formatAgentName(email),
        userId
      });
    }
    
    // Tri par numéro d'agent (agent-0, agent-1, ..., agent-230)
    agents.sort((a, b) => {
      const getAgentNumber = (email: string) => {
        const match = email.match(/agent-(\d+)@/);
        if (match) return parseInt(match[1]);
        
        const trainingMatch = email.match(/training_account_(\d+)@/);
        if (trainingMatch) return 10000 + parseInt(trainingMatch[1]); // Training accounts à la fin
        
        return 20000; // Autres comptes à la fin
      };
      
      return getAgentNumber(a.email) - getAgentNumber(b.email);
    });
    
    console.log('📋 Agents disponibles:', agents.length, {
      agents: agents.slice(0, 5),
      training: agents.filter(a => a.email.includes('training')).length,
      regular: agents.filter(a => a.email.includes('agent-')).length
    });
    
    return agents;
  }

  /**
   * 🆕 Méthode pour obtenir les agents les plus récents (priorité)
   */
  getRecentAgents(limit: number = 20): Agent[] {
    const allAgents = this.getAllAvailableAgents();
    
    // Filtrer les agents reguliers et prendre les plus récents
    const regularAgents = allAgents
      .filter(agent => agent.email.includes('agent-'))
      .reverse() // Commencer par les numéros les plus élevés
      .slice(0, limit);
    
    console.log('⭐ Agents récents (top', limit, '):', regularAgents.map(a => a.email));
    return regularAgents;
  }

  
  /**
   * Requête générique vers l'API Redash avec polling du job
   */
  private async makeApiRequest(queryId: string, parameters: any, maxRetries: number = 5): Promise<any> {
    try {
      const requestBody = {
        id: parseInt(queryId),
        parameters,
        apply_auto_limit: false
      };
  
      // ✅ FIX: Ajouter le préfixe /api
      const apiBase = withApiBase(this.baseUrl);
      const apiUrl = `${apiBase}/queries/${queryId}/results`;
      console.log('🚀 Soumission requête vers PROXY:', apiUrl);
      console.log('📦 Body:', requestBody);
  
      // 1. Soumettre la requête
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erreur API: ${response.status} - ${errorText}`);
      }
  
      const data = await response.json();
      console.log('✅ Réponse initiale:', Object.keys(data));
  
      // 2. Si on a directement les données, les retourner
      if (data?.query_result?.data?.rows) {
        console.log('📊 Données immédiates - Nombre de lignes:', data.query_result.data.rows.length);
        return data.query_result.data.rows;
      }
  
      // 3. Si c'est un job, attendre qu'il se termine
      if (data?.job?.id) {
        console.log('⏳ Job créé:', data.job.id, '- Polling en cours...');
        return await this.pollJobResult(data.job.id, maxRetries);
      }
  
      // 4. Format inattendu
      console.log('📊 Format inattendu:', data);
      throw new Error(`Format de réponse inattendu: ${Object.keys(data).join(', ')}`);
  
    } catch (error) {
      console.error('💥 Erreur makeApiRequest:', error);
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        throw new Error('ERREUR SERVEUR PROXY: Vérifiez localhost:3001');
      }
      throw error;
    }
  }

  async getCombinedTasksAndPerformanceStats(params: TotalTasksParams): Promise<CombinedTasksAndPerformanceResult> {
    try {
      console.log('🚀 [TOTAL-TASKS] Récupération statistiques combinées:', params);
  
      // Construire les paramètres avec le FORMAT OBJET pour les stats
      const redashParams = this.buildStatsParameters({
        dateFrom: params.dateFrom,
        dateTo: params.dateTo
      });

      console.log('🔧 [TOTAL-TASKS] Paramètres Redash construits (format objet):', redashParams);
  
      // Récupérer les données en parallèle des deux APIs Redash
      const [taskStatsRaw, performanceStatsRaw] = await Promise.all([
        this.makeApiRequest('5373', redashParams), // Query pour les task stats
        this.makeApiRequest('5372', redashParams)  // Query pour les performance stats
      ]);
  
      console.log('📊 [TOTAL-TASKS] Données brutes reçues:', {
        taskStats: Array.isArray(taskStatsRaw) ? taskStatsRaw.length : 'Non-array',
        performanceStats: Array.isArray(performanceStatsRaw) ? performanceStatsRaw.length : 'Non-array',
        sampleTask: taskStatsRaw?.[0],
        samplePerf: performanceStatsRaw?.[0]
      });
  
      // Traitement des task stats avec calcul des pair_only_tasks
      const taskStats: ProcessedAgentTaskStats[] = Array.isArray(taskStatsRaw) ? 
        taskStatsRaw.map((task: any) => {
          const totalDrawTasks = task.total_draw_tasks || 0;
          const totalMatchDrawEditTasks = task.total_match_draw_edit_tasks || 0;
          const totalPairTasks = task.total_pair_tasks || 0;
          const totalReviewTasks = task.total_review_tasks || 0;
          
          // Calcul du pair_only_tasks = Total Pair - Total Draw
          const pairOnlyTasks = Math.max(0, totalPairTasks - totalDrawTasks);
          
          // Calcul du total de toutes les tâches
          const totalAllTasks = totalDrawTasks + totalMatchDrawEditTasks + totalPairTasks + totalReviewTasks;
          
          return {
            email: task.email || '',
            total_draw_tasks: totalDrawTasks,
            total_match_draw_edit_tasks: totalMatchDrawEditTasks,
            total_pair_tasks: totalPairTasks,
            total_review_tasks: totalReviewTasks,
            pair_only_tasks: pairOnlyTasks,
            total_all_tasks: totalAllTasks
          };
        }) : [];
  
      // Traitement des performance stats
      const performanceStats: AgentPerformanceStats[] = Array.isArray(performanceStatsRaw) ?
        performanceStatsRaw.map((perf: any) => ({
          email: perf.email || '',
          total_gs_tasks: perf.total_gs_tasks || 0,
          average_draw_score: parseFloat(perf.average_draw_score) || 0,
          average_pair_score: parseFloat(perf.average_pair_score) || 0,
          average_label_score: parseFloat(perf.average_label_score) || 0,
          average_area_score: parseFloat(perf.average_area_score) || 0,
          total_average_f1: parseFloat(perf.total_average_f1) || 0
        })) : [];
  
      // Filtrage par agents sélectionnés si spécifié
      let filteredTaskStats = taskStats;
      let filteredPerformanceStats = performanceStats;
  
      if (params.selectedAgents && params.selectedAgents.length > 0) {
        console.log('🔍 [TOTAL-TASKS] Filtrage par agents sélectionnés:', params.selectedAgents);
        filteredTaskStats = taskStats.filter(task => 
          params.selectedAgents!.includes(task.email)
        );
        filteredPerformanceStats = performanceStats.filter(perf => 
          params.selectedAgents!.includes(perf.email)
        );
      }
  
      console.log('✅ [TOTAL-TASKS] Données traitées:', {
        taskStats: filteredTaskStats.length,
        performanceStats: filteredPerformanceStats.length,
        sampleProcessedTask: filteredTaskStats[0] ? {
          email: filteredTaskStats[0].email,
          totalTasks: filteredTaskStats[0].total_all_tasks,
          pairOnly: filteredTaskStats[0].pair_only_tasks,
          drawTasks: filteredTaskStats[0].total_draw_tasks,
          pairTasks: filteredTaskStats[0].total_pair_tasks
        } : 'Aucune',
        sampleProcessedPerf: filteredPerformanceStats[0] ? {
          email: filteredPerformanceStats[0].email,
          f1Score: filteredPerformanceStats[0].total_average_f1,
          drawScore: filteredPerformanceStats[0].average_draw_score
        } : 'Aucune'
      });
  
      return {
        taskStats: filteredTaskStats,
        performanceStats: filteredPerformanceStats
      };
  
    } catch (error) {
      console.error('💥 [TOTAL-TASKS] Erreur getCombinedTasksAndPerformanceStats:', error);
      
      // Informations de debug pour identifier le problème
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        console.error('🔧 [TOTAL-TASKS] Erreur réseau - Vérifiez que le serveur proxy tourne sur localhost:3001');
        throw new Error('Serveur proxy inaccessible. Vérifiez localhost:3001');
      }
      
      throw new Error(`Erreur récupération données Total Tasks: ${error}`);
    }
  }
  
  // ✅ Aussi corriger pollJobResult :
  private async pollJobResult(jobId: string, maxRetries: number): Promise<any> {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        console.log(`🔄 Polling job ${jobId} (tentative ${attempt}/${maxRetries})...`);
        
        // ✅ FIX: Ajouter le préfixe /api
        const apiBase = withApiBase(this.baseUrl);
        const response = await fetch(`${apiBase}/jobs/${jobId}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          }
        });
  
        if (!response.ok) {
          throw new Error(`Erreur polling: ${response.status}`);
        }
  
        const jobData = await response.json();
        console.log('📡 Job status:', jobData.job?.status, '- ID:', jobData.job?.id);
  
        const jobStatus = jobData.job?.status;
  
        if (jobStatus === 3 || jobStatus === 'success') {
          // Job terminé avec succès
          const rows = jobData.job?.query_result?.data?.rows || [];
          console.log('✅ Job terminé - Nombre de lignes:', rows.length);
          return rows;
          
        } else if (jobStatus === 4 || jobStatus === 'failed') {
          // Job échoué
          const errorMessage = jobData.job?.error || 'Erreur inconnue';
          console.error('❌ Job échoué:', errorMessage);
          throw new Error(`Job échoué: ${errorMessage}`);
        } else if (jobStatus === 1 || jobStatus === 2 || jobStatus === 'pending' || jobStatus === 'running') {
          // Job en cours, attendre
          if (attempt < maxRetries) {
            console.log(`⏳ Job en cours (status ${jobStatus}), attente 4s...`);
            await sleep(4000);
            continue;
          } else {
            throw new Error('Job trop long à s\'exécuter');
          }
        } else {
          throw new Error(`Status job inconnu: ${jobStatus}`);
        }
  
      } catch (error) {
        console.error(`💥 Erreur polling tentative ${attempt}:`, error);
        if (attempt === maxRetries) {
          throw error;
        }
        await sleep(2000);
      }
    }
  
    throw new Error('Polling échoué après toutes les tentatives');
  }
  
  // ✅ Aussi corriger testProxyServer :
  async testProxyServer(): Promise<boolean> {
    try {
      console.log('🔍 Test connexion serveur proxy...');
      const response = await fetch(`${PROXY_SERVER_URL}/test`);
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Serveur proxy OK:', data.message);
        return true;
      } else {
        console.error('❌ Serveur proxy erreur:', response.status);
        return false;
      }
    } catch (error) {
      console.error('❌ Serveur proxy inaccessible:', error);
      return false;
    }
  }

  /**
   * Récupère les tâches Pair Only - CORRIGÉ
   */
  async getPairOnlyTasks(params: AuditDataParams = {}): Promise<ParsedTask[]> {
    const parameters = this.buildTaskParameters(params); // Utiliser le format simple
    console.log('🔍 Paramètres Pair Only (format simple):', parameters);

    const rawData = await this.makeApiRequest(QUERY_IDS.PAIR_ONLY_TASKS, parameters);
    return this.parseAuditData(rawData, 'pair_only');
  }

  /**
   * Récupère les tâches Complete Match - CORRIGÉ
   */
  async getCompleteMatchTasks(params: AuditDataParams = {}): Promise<ParsedTask[]> {
    const parameters = this.buildTaskParameters(params); // Utiliser le format simple
    console.log('🔍 Paramètres Complete Match (format simple):', parameters);

    const rawData = await this.makeApiRequest(QUERY_IDS.COMPLETE_MATCH_TASKS, parameters);
    return this.parseAuditData(rawData, 'complete_match');
  }

  /**
   * 🔄 Récupère TOUTES les tâches d'audit avec debug amélioré
   */
  async getAllAuditData(params: AuditDataParams = {}): Promise<ParsedTask[]> {
    console.log('🚀 === RÉCUPÉRATION TOUTES DONNÉES ===');
    console.log('📋 Paramètres:', params);
    
    try {
      const builtParams = this.buildTaskParameters(params); // Utiliser le format simple pour les tâches
      console.log('🔧 Paramètres construits:', builtParams);

      // Parallélisation des requêtes avec gestion d'erreur
      const [pairResult, matchResult] = await Promise.allSettled([
        this.getPairOnlyTasks(params),
        this.getCompleteMatchTasks(params)
      ]);

      let pairTasks: ParsedTask[] = [];
      let matchTasks: ParsedTask[] = [];

      if (pairResult.status === 'fulfilled') {
        pairTasks = pairResult.value;
        console.log('✅ Pair Only réussi:', pairTasks.length, 'tâches');
      } else {
        console.error('❌ Pair Only échoué:', pairResult.reason);
      }

      if (matchResult.status === 'fulfilled') {
        matchTasks = matchResult.value;
        console.log('✅ Complete Match réussi:', matchTasks.length, 'tâches');
      } else {
        console.error('❌ Complete Match échoué:', matchResult.reason);
      }

      const allTasks = [...pairTasks, ...matchTasks];
      
      console.log('📊 === RÉSUMÉ FINAL ===');
      console.log(`📦 Pair Only: ${pairTasks.length} tâches`);
      console.log(`🔄 Complete Match: ${matchTasks.length} tâches`);
      console.log(`🎯 Total: ${allTasks.length} tâches`);
      
      if (allTasks.length > 0) {
        console.log('📋 Exemple première tâche:', {
          id: allTasks[0].match_task_id,
          type: allTasks[0].task_type,
          email: allTasks[0].email,
          date: allTasks[0].date,
          state: allTasks[0].state,
          hasTemplateImages: allTasks[0].template_image_urls.length > 0,
          hasPlanoImages: allTasks[0].plano_image_urls.length > 0,
          hasModelTemplate: allTasks[0].model_drawn_template_urls.length > 0,
          hasAgentSubmitted: allTasks[0].agent_submitted_urls.length > 0
        });
      } else {
        console.warn('⚠️ AUCUNE TÂCHE TROUVÉE - Vérifiez:');
        console.warn('- Date existe dans les données');
        console.warn('- Agent a des tâches cette date');
        console.warn('- Paramètres corrects:', builtParams);
      }
      
      return allTasks;
      
    } catch (error) {
      console.error('💥 Erreur getAllAuditData:', error);
      throw error;
    }
  }

  /**
   * 🆕 Parse et nettoie les données de l'API avec extraction d'images CORRIGÉE
   */
  private parseAuditData(rawData: any[], taskType: 'pair_only' | 'complete_match'): ParsedTask[] {
    console.log(`🔄 Parsing ${taskType}:`, {
      isArray: Array.isArray(rawData),
      length: rawData?.length || 0
    });

    if (!Array.isArray(rawData)) {
      console.warn('⚠️ Données non-array reçues:', rawData);
      return [];
    }

    if (rawData.length === 0) {
      console.warn(`⚠️ Aucune donnée ${taskType}`);
      return [];
    }

    // Log de la première entrée pour debug
    console.log(`📋 Première entrée ${taskType}:`, {
      keys: Object.keys(rawData[0] || {}),
      sample: rawData[0]
    });

    return rawData.map((task: any, index: number) => {
      try {
        // 🎯 CORRECTION: Gestion correcte des images pour Pair Only vs Complete Match
        let templateImageUrls: string[] = [];
        let agentSubmittedUrls: string[] = [];
        let modelDrawnTemplateUrls: string[] = [];
        let issueNames = '';

        if (taskType === 'pair_only') {
          // Pour Pair Only:
          // - template_image contient l'image agent submitted (HTML)
          // - model_drawn_template contient l'URL du modèle (URL simple)
          // - issue_labels → issue_names
          agentSubmittedUrls = this.extractImageUrls(task.template_image);
          modelDrawnTemplateUrls = [task.model_drawn_template].filter(Boolean);
          templateImageUrls = []; // Pas d'image template séparée en Pair Only
          issueNames = this.cleanHtmlTags(task.issue_labels); // issue_labels pour pair_only
        } else {
          // Pour Complete Match:
          // - template_image contient l'image template (HTML)
          // - Pas de model_drawn_template ni agent_submitted
          // - issue_names directement
          templateImageUrls = this.extractImageUrls(task.template_image);
          agentSubmittedUrls = [];
          modelDrawnTemplateUrls = [];
          issueNames = task.issue_names || ''; // issue_names pour complete_match
        }

        const parsed: ParsedTask = {
          match_task_id: task.match_task_id || 0,
          date: task.utc_time_task_submitted || new Date().toISOString(),
          state: task.state || 'unknown',
          email: task.email || 'unknown@email.com',
          priority_names: task.priority_names || '',
          issue_names: issueNames,
          processing_time_seconds: task.processing_time_seconds || 0,
          template_unpaired: task.template_unpaired || 0,
          template_total: task.template_total || 0,
          plano_unpaired: Math.floor(task.plano_unpaired || 0),
          plano_total: Math.floor(task.plano_total || 0),
          template_image: task.template_image || '',
          plano_image: task.plano_image || '',
          model_drawn_template: task.model_drawn_template || '',
          template_image_urls: templateImageUrls,
          plano_image_urls: this.extractImageUrls(task.plano_image),
          model_drawn_template_urls: modelDrawnTemplateUrls,
          agent_submitted_urls: agentSubmittedUrls,
          model_template_used: task.model_template_used || 0,
          unlock_draw_mode_used: task.unlock_draw_mode_used || 0,
          task_type: taskType
        };

        // Log pour les premières entrées
        if (index < 2) {
          console.log(`📋 Parsed ${taskType} [${index}]:`, {
            id: parsed.match_task_id,
            email: parsed.email,
            date: parsed.date,
            state: parsed.state,
            templateImages: parsed.template_image_urls.length,
            planoImages: parsed.plano_image_urls.length,
            modelTemplateImages: parsed.model_drawn_template_urls.length,
            agentSubmittedImages: parsed.agent_submitted_urls.length,
            modelTemplateUsed: parsed.model_template_used,
            unlockDrawMode: parsed.unlock_draw_mode_used
          });
          
          // Log détaillé des URLs extraites
          console.log(`🖼️ URLs ${taskType} [${index}]:`, {
            templateImageUrls: parsed.template_image_urls,
            agentSubmittedUrls: parsed.agent_submitted_urls,
            modelDrawnTemplateUrls: parsed.model_drawn_template_urls,
            planoImageUrls: parsed.plano_image_urls.slice(0, 2) // Première plano seulement
          });
        }

        return parsed;
      } catch (error) {
        console.error(`💥 Erreur parsing ${taskType} [${index}]:`, error, task);
        return null;
      }
    }).filter(Boolean) as ParsedTask[];
  }

  /**
   * Nettoie les balises HTML
   */
  private cleanHtmlTags(htmlString: string | null): string {
    if (!htmlString) return '';
    return htmlString.replace(/<br\s*\/?>/gi, ', ').replace(/<[^>]*>/g, '');
  }

  /**
   * 🆕 Extrait les URLs d'images du HTML avec debug amélioré
   */
  private extractImageUrls(imageHtml: string | null): string[] {
    if (!imageHtml) return [];
    
    console.log('🔍 HTML à analyser:', imageHtml.substring(0, 200) + '...');
    
    const urls: string[] = [];
    
    // 🎯 MÉTHODE 1: Extraction des src d'images
    const srcMatches = imageHtml.matchAll(/src="([^"]+)"/g);
    
    for (const match of srcMatches) {
      const url = match[1];
      // Filtrer les URLs valides
      if (url && !url.startsWith('data:') && url.length > 10) {
        urls.push(url);
      }
    }
    
    // 🎯 MÉTHODE 2: Si pas d'images trouvées, essayer les href des liens
    if (urls.length === 0) {
      console.log('🔍 Aucune image src trouvée, essai avec href...');
      const hrefMatches = imageHtml.matchAll(/href="([^"]+)"/g);
      
      for (const match of hrefMatches) {
        const url = match[1];
        // Vérifier si l'URL contient des paramètres d'image
        if (url && (url.includes('.jpg') || url.includes('.png') || url.includes('/draw?'))) {
          urls.push(url);
        }
      }
    }
    
    // 🎯 MÉTHODE 3: Extraction manuelle pour le format spécifique
    if (urls.length === 0) {
      console.log('🔍 Extraction manuelle...');
      
      // Chercher les URLs avec le pattern focal.systems
      const focalMatches = imageHtml.matchAll(/https:\/\/dl-viz\.focal\.systems\/[^"'\s>]+/g);
      for (const match of focalMatches) {
        urls.push(match[0]);
      }
    }
    
    // 🎯 NETTOYAGE: Supprimer les doublons
    const uniqueUrls = [...new Set(urls)];
    
    console.log(`🖼️ URLs extraites:`, {
      total: uniqueUrls.length,
      urls: uniqueUrls.map(url => url.substring(0, 80) + '...')
    });
    
    return uniqueUrls;
  }

  /**
   * Test de connexion COMPLET avec debug
   */
  async testConnection(): Promise<boolean> {
    try {
      console.log('🔍 Test de connexion complet...');
      
      // 1. Test proxy
      const proxyOk = await this.testProxyServer();
      if (!proxyOk) {
        throw new Error('Serveur proxy inaccessible sur localhost:3001');
      }
      
      // 2. Test données réelles avec un agent récent
      const recentAgents = this.getRecentAgents(5);
      const testAgent = recentAgents[0]?.email || 'agent-230@oworkers.com';
      
      const testData = await this.getAllAuditData({
        dateFrom: '2025-07-22',
        dateTo: '2025-07-22',
        userEmail: testAgent
      });
      
      console.log('✅ Test connexion API réussi:', testData.length, 'tâches trouvées pour', testAgent);
      return true;
      
    } catch (error) {
      console.error('❌ Test connexion échoué:', error);
      return false;
    }
  }

  /**
   * 🆕 NOUVELLE MÉTHODE: Récupère les agents qui ont des tâches pour une période donnée
   */
  async getAvailableAgents(dateFrom: string, dateTo: string): Promise<Agent[]> {
    try {
      console.log('🔍 Recherche agents actifs pour période:', { dateFrom, dateTo });
      
      // On teste d'abord avec les agents récents pour optimiser
      const recentAgents = this.getRecentAgents(30);
      const foundAgents: Agent[] = [];
      
      // Test en parallèle de quelques agents récents
      const testPromises = recentAgents.slice(0, 10).map(async (agent) => {
        try {
          const tasks = await this.getAllAuditData({
            dateFrom,
            dateTo,
            userEmail: agent.email
          });
          
          if (tasks.length > 0) {
            console.log(`✅ Agent actif trouvé: ${agent.email} (${tasks.length} tâches)`);
            return agent;
          }
          return null;
        } catch (error) {
          console.log(`⚠️ Agent ${agent.email}: pas de données`);
          return null;
        }
      });
      
      const results = await Promise.allSettled(testPromises);
      
      results.forEach((result) => {
        if (result.status === 'fulfilled' && result.value) {
          foundAgents.push(result.value);
        }
      });
      
      // Si pas assez d'agents trouvés, ajouter la liste statique
      if (foundAgents.length < 5) {
        console.log('📝 Ajout agents statiques supplémentaires...');
        const staticAgents = this.getRecentAgents(20);
        
        staticAgents.forEach(agent => {
          if (!foundAgents.find(found => found.email === agent.email)) {
            foundAgents.push(agent);
          }
        });
      }
      
      console.log(`📋 Total agents disponibles: ${foundAgents.length}`);
      return foundAgents;
      
    } catch (error) {
      console.error('💥 Erreur récupération agents, fallback sur liste statique:', error);
      return this.getRecentAgents(20);
    }
  }

  private formatAgentName(email: string): string {
    if (!email) return 'Agent inconnu';
    
    if (email.includes('training_account_')) {
      const match = email.match(/training_account_(\d+)@/);
      return match ? `Formation ${match[1]}` : 'Compte Formation';
    }
    
    if (email.includes('agent-')) {
      const match = email.match(/agent-(\d+)@/);
      return match ? `Agent ${match[1]}` : 'Agent';
    }
    
    if (email.includes('test@')) {
      return 'Compte Test';
    }
    
    const username = email.split('@')[0];
    return username.charAt(0).toUpperCase() + username.slice(1).replace(/[-_]/g, ' ');
  }

  formatDuration(seconds: number): string {
    if (!seconds) return '0s';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return minutes > 0 ? `${minutes}m ${remainingSeconds}s` : `${remainingSeconds}s`;
  }

  /**
   * Calcule les statistiques d'audit
   */
  calculateStats(tasks: ParsedTask[]): TaskStats {
    const stats: TaskStats = {
      totalTasks: tasks.length,
      completedTasks: tasks.filter(t => t.state === 'completed').length,
      rejectedTasks: tasks.filter(t => t.state === 'rejected').length,
      avgProcessingTime: tasks.length > 0 ? tasks.reduce((sum, t) => sum + t.processing_time_seconds, 0) / tasks.length : 0,
      tasksByAgent: {},
      tasksByDay: {}
    };
    
    // Statistiques par agent
    tasks.forEach(task => {
      if (!stats.tasksByAgent[task.email]) {
        stats.tasksByAgent[task.email] = { total: 0, completed: 0, rejected: 0 };
      }
      stats.tasksByAgent[task.email].total++;
      if (task.state === 'completed') stats.tasksByAgent[task.email].completed++;
      if (task.state === 'rejected') stats.tasksByAgent[task.email].rejected++;
    });

    // Statistiques par jour
    tasks.forEach(task => {
      const day = task.date.split('T')[0];
      if (!stats.tasksByDay[day]) {
        stats.tasksByDay[day] = { total: 0, completed: 0, rejected: 0 };
      }
      stats.tasksByDay[day].total++;
      if (task.state === 'completed') stats.tasksByDay[day].completed++;
      if (task.state === 'rejected') stats.tasksByDay[day].rejected++;
    });

    return stats;
  }
  
}

export const focalApiService = new FocalApiService();
export default focalApiService;